import { createSubject, deleteSubject, getSubjects, updateSubject } from "../../api/subject";
import { toArray, toObject } from "../../utils/languageContent";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

const subject = {
    namespaced: true,
    state: {
        subjects: {
            count: 0,
            data: [],
            total: 0,
        },
        selectedSubject: null,
    },
    getters: {
        getUndeleted: (state) => {
            return state.subjects.data.filter((p) => p.isDeleted === false);
        },
        getUserSubjects: (state, getters, rootState) => {
            let userSubs = _.get(rootState.auth, "user.subjects", []);
            if (userSubs.length === 0) return state.subjects.data;
            return state.subjects.data.filter((x) => userSubs.includes(x._id));
        },
    },
    mutations: {
        SET_SUBJECTS: (state, payload) => {
            state.subjects = payload;
        },
        ADD_SUBJECT: (state, payload) => {
            state.subjects.data.push(payload);
            state.subjects.total++;
        },
        UPDATE_SUBJECT: (state, payload) => {
            const index = state.subjects.data.findIndex((p) => p._id === payload._id);
            state.subjects.data[index] = payload;
        },
        DELETE_SUBJECT: (state, id) => {
            state.subjects.data = state.subjects.data.filter((r) => r._id !== id);
            state.subjects.total--;
        },
        UPDATE_SELECTED_SUBJECT(state, id) {
            state.selectedSubject = id;
        },
    },
    actions: {
        getSubjects({ commit }, payload) {
            return getSubjects(payload.perPage, payload.page).then((response) => {
                const total = response.data.total;
                const count = response.data.count;
                const data = response.data.data.map((x) => toObject(x));
                commit("SET_SUBJECTS", { data, count, total });
                return response;
            });
        },
        setSubjects({ commit }, subjects) {
            const total = subjects.length;
            const count = subjects.length;
            const data = subjects.map((x) => toObject(x));
            commit("SET_SUBJECTS", { data, count, total });
        },
        getSubject({ state }, id) {
            return state.subjects.data.find((p) => p._id === id);
        },
        createSubject({ commit }, payload) {
            return createSubject(toArray(payload)).then((response) => {
                commit("ADD_SUBJECT", toObject(response.data));

                return Promise.resolve(response);
            });
        },
        updateSubject({ commit }, payload) {
            return updateSubject(payload._id, toArray(payload)).then((response) => {
                commit("UPDATE_SUBJECT", toObject(response.data));
            });
        },
        deleteSubject({ commit }, id) {
            return deleteSubject(id).then((response) => {
                commit("DELETE_SUBJECT", id);
            });
        },
        updateSelectedSubject({ commit }, id) {
            commit("UPDATE_SELECTED_SUBJECT", id);
        },
    },
};

export default subject;
